import { createContext } from 'react';

export const FlowStrategyContext = createContext({});
